/**
 * @generated SignedSource<<2b6c615ab97c9a068d76ac7c815439d1>>
 * @relayHash 7139ae821fb8dee122aa626f172fbb9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 87e40fa23f301d7d409db9acf74d1bacd4cf5e5bf2dfdc9c6c70f178d4f13946

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamSortField = "DISPLAY_NAME" | "ID" | "IS_VERIFIED" | "STATE" | "%future added value";
export type TeamSortOrder = "ASC" | "DESC" | "%future added value";
export type TeamSearchFilter = {
  customFieldValues?: TeamCustomFieldValuesFilter | null;
  membership?: TeamMembershipFilter | null;
  query?: string | null;
  teamTypes?: TeamTypeFilter | null;
};
export type TeamCustomFieldValuesFilter = {
  customFieldValueIds?: ReadonlyArray<string | null> | null;
};
export type TeamMembershipFilter = {
  memberIds?: ReadonlyArray<string | null> | null;
};
export type TeamTypeFilter = {
  teamTypeIds?: ReadonlyArray<string | null> | null;
};
export type TeamSort = {
  field: TeamSortField;
  order?: TeamSortOrder | null;
};
export type TeamsAppForYouAGGQuery$variables = {
  organizationId: string;
  siteId: string;
  teamFilter: TeamSearchFilter;
  teamSortBy: ReadonlyArray<TeamSort | null>;
};
export type TeamsAppForYouAGGQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamsRowQuery">;
};
export type TeamsAppForYouAGGQuery = {
  response: TeamsAppForYouAGGQuery$data;
  variables: TeamsAppForYouAGGQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamSortBy"
  }
],
v1 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "teamFilter"
},
v2 = {
  "kind": "Variable",
  "name": "organizationId",
  "variableName": "organizationId"
},
v3 = {
  "kind": "Variable",
  "name": "siteId",
  "variableName": "siteId"
},
v4 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "teamSortBy"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = {
  "kind": "ScalarField",
  "name": "memberCount"
},
v11 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v12 = {
  "kind": "ScalarField",
  "name": "description"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TeamsAppForYouAGGQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TeamsRowQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamsAppForYouAGGQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              },
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "concreteType": "TeamSearchResultConnectionV2",
            "kind": "LinkedField",
            "name": "teamSearchV2",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResultEdgeV2",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResultV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TeamV2",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "largeAvatarImageUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "state"
                          },
                          {
                            "concreteType": "TeamMemberV2",
                            "kind": "LinkedField",
                            "name": "membersPreview",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v5/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "concreteType": "TeamType",
                            "kind": "LinkedField",
                            "name": "type",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v5/*: any*/),
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "verified"
                              }
                            ]
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 100
                              }
                            ],
                            "concreteType": "TeamMemberConnectionV2",
                            "kind": "LinkedField",
                            "name": "members",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamMemberEdgeV2",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v7/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "members(first:100)"
                          },
                          (v12/*: any*/)
                        ]
                      },
                      (v10/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "TeamSearchResultV2",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      (v11/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 20
                          }
                        ],
                        "concreteType": "TeamMemberConnectionV2",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamMemberEdgeV2",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamMemberV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                      },
                                      (v9/*: any*/),
                                      (v8/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "members(first:20)"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "87e40fa23f301d7d409db9acf74d1bacd4cf5e5bf2dfdc9c6c70f178d4f13946",
    "metadata": {},
    "name": "TeamsAppForYouAGGQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eeb8cb1c20f19d1faf0ef21d43894223";

export default node;
